import React from 'react'
import ContentLoader from 'react-content-loader'
import cardClasses from '../Cards/SubscriptionCard/subscriptioncard.module.css'

const NUM_PLACEHOLDER_FEATURES = 5

export const SubscriptionLoader = props => (
    <ContentLoader
        style={{ minHeight: 500 }}
        className={cardClasses.card}
        {...props}
    >
        <rect x={'30%'} y={20} width={'40%'} height={20} />
        <rect x={'20%'} y={70} width={'60%'} height={45} />
        <rect x={'10%'} y={140} width={'80%'} height={20} />
        {new Array(NUM_PLACEHOLDER_FEATURES).fill(null).map((_, index) => (
            <rect
                key={index}
                x={'25%'}
                y={170 + (index * 20 + 20 + index * 15)}
                width={'50%'}
                height={20}
            />
        ))}
        {/* The loader ends up being around 460px in height due to the padding on the card */}
        <rect x={'15%'} y={460 - 45} width={'70%'} height={40} rx={10} />
    </ContentLoader>
)
